import DisabledTooltip from '@components/DisabledTooltip';
import { ListItemButton, ListItemIcon } from '@mui/material';
import RejectIcon from '@mui/icons-material/CancelPresentationTwoTone';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useAppDispatch } from '@reduxStore';
import { queueModal } from '@components/Modals/modalSlice';

export default function RejectLoadTenderListItem() {
	const gridApi = useGridApiContext();
	const selectedRowIds = useGridSelector(gridApi, gridRowSelectionIdsSelector);
	const appDispatch = useAppDispatch();

	const isDisabled = useMemo(() => selectedRowIds.size !== 1, [selectedRowIds]);

	const title = isDisabled ? 'This action requires a single row selection.' : undefined;

	const handleClick = () => {
		const id = Number(selectedRowIds.keys().next().value);
		appDispatch(
			queueModal({
				Component: 'ediRejectLoadTenderModal',
				Props: {
					loadTenderId: id
				}
			})
		);
	};

	return (
		<DisabledTooltip
			message={title}
			placement='right'
		>
			<ListItemButton
				disabled={isDisabled}
				onClick={handleClick}
			>
				<ListItemIcon sx={{ minWidth: '24px' }}>
					<RejectIcon
						fontSize='small'
						color='warning'
					/>
				</ListItemIcon>
				Reject
			</ListItemButton>
		</DisabledTooltip>
	);
}
